import { UserIcon } from "app/components/Icons";
import CustomTooltip from "app/components/Tooltip";
import Avatar from "app/containers/Features/components/Avatar";
import CommonAssigneeSelection from "app/containers/Features/components/CommonAssigneeSelection";
import { selectTeamMembers } from "app/redux/selector";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../containers/Tickets/redux/slice";
import { IMember } from "../../../ProjectSettings/types";

interface CustomProps {
  assignedTo: string;
  onOpen: () => void;
  onClose: () => void;
}

const SelectAssignee: React.FC<CustomProps> = ({ assignedTo ,onClose,onOpen}) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedMember, setSelectedMember] = useState<IMember | null>(null);
  const selectTeamMember = useSelector(selectTeamMembers);
  const searchMembers = (members, keyword: string): IMember[] => {
    if (!keyword) return members;
    return members.filter(
      (member) =>
        member.name.toLowerCase().includes(keyword.toLowerCase()) ||
        member.role.toLowerCase().includes(keyword.toLowerCase())
    );
  };

  const handleSelect = (member: IMember) => {
    dispatch(
      actions.setTicketFormValue({ name: "assignedTo", value: member?._id })
    );
    setSelectedMember(member);
    setOpen(false);
  };

  const filteredMembers = searchMembers(selectTeamMember, searchTerm);
  return (
    <>
      <CommonAssigneeSelection
        trigger={
          <button className="flex items-center justify-between w-full p-[6px] rounded-md hover:bg-[#F4F5F7] rounded-[4px] data-[state=open]:border-[#79808A] data-[state=open]:outline-[#79808A] data-[state=open]:border-[1px] border-[#79808A]">
            <CustomTooltip
              text="Click to choose assignee"
              className="flex items-center gap-1 "
              position="left"
            >
              {selectedMember ? (
                <div  className="flex  gap-2">
                  <UserIcon size={16} />
                  <Avatar
                    color={selectedMember?.icon?.color ?? "#79808A"}
                    name={selectedMember.name ?? selectedMember?.name[0]}
                    className=" w-full truncate"
                    circleClassName="text-[6.4px] leading-[19.2px] font-normal !size-[16px]"
                    statusClassName="size-[3.2px]"
                    nameClassName="text-xs leading-[18px] font-normal text-secondary truncate"
                    detailsClassName="w-full"
                  />
                </div>
              ) : (
                <span className="text-xs leading-[18px] font-normal text-secondary ">
                  Choose assignee
                </span>
              )}
            </CustomTooltip>
          </button>
        }
        align="center"
        searchKeyword={searchTerm}
        setSearchKeyword={(val) => {
          setSearchTerm(val);
        }}
        data={filteredMembers}
        selectedValue={assignedTo}
        updateValue={(member) => {
          handleSelect(member);
        }}
        isHeader="Assignees"
        searchPlaceholder="Search by assignee or role "
        onClose={onClose}
        onOpen={onOpen}
      />
    </>
  );
};

export default SelectAssignee;
